export default __webpack_public_path__ + "static/media/indxxf.c28ed48c.svg";